var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"social-connector text-center auth-or-divider",class:_vm.marginClass},[_c('span',[_vm._v(_vm._s(_vm.$t("auth.or")))])])}
var staticRenderFns = []

export { render, staticRenderFns }